<form
  class="field-dialog__content__scroll p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  *ngIf="categoriesArray.controls"
  class="field-dialog__content__scroll tab-permissions"
  name="form"
  autocomplete="off"
  fusePerfectScrollbar
>
  <div *ngFor="let category of categoriesArray.controls; index as categoryIndex" fxLayout="column">
    <div
      class="tab-permissions__outer-item"
      [class.tab-permissions__outer-item--expanded]="category.get('expanded').value"
      *ngIf="isVisiblePermissionCategory(category)"
    >
      <div class="tab-permissions__check-and-text">
        <div>
          <mat-checkbox
            id="check-box-category-{{ category.get('name').value }}"
            [formControl]="category.get('checked')"
            [indeterminate]="category.get('indeterminate').value"
            [checked]="category.get('checked').value"
            (change)="onCategorySelectionChange($event.checked, category)"
            #checkbox
          ></mat-checkbox>
        </div>

        <div class="permission-label">
          <p class="permission-label__title" (click)="toggleCategory(category)">
            {{ category.get('title').value }}
          </p>
          <p class="permission-label__description">{{ category.get('description').value }}</p>
        </div>
      </div>

      <div id="button-expanded">
        <button class="tab-permissions__expand-button" mat-icon-button (click)="switchCategoryExpansion(category)">
          <mat-icon>
            {{ category.get('expanded').value ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
      </div>
    </div>

    <ng-container *ngIf="category.get('expanded').value">
      <div class="tab-permissions__subitem" *ngFor="let permission of category.get('permissions')['controls']">
        <ng-container>
          <div>
            <mat-checkbox
              id="permission-check-box-{{ permission.get('name').value }}"
              name="permission-selected"
              [formControl]="permission.get('checked')"
              [checked]="permission.get('checked').value"
              (change)="onPermissionSelectionChange(category)"
            >
            </mat-checkbox>
          </div>
          <div class="permission-label">
            <p class="permission-label__title" (click)="togglePermission(category, permission)">
              {{ permission.get('title').value }}
            </p>
            <p class="permission-label__description">{{ permission.get('description').value }}</p>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</form>
